import { render, staticRenderFns } from "./videoMarkingTable.vue?vue&type=template&id=7f07fdd4&scoped=true&"
import script from "./videoMarkingTable.vue?vue&type=script&lang=js&"
export * from "./videoMarkingTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f07fdd4",
  null
  
)

export default component.exports